import { string } from 'yup';
import type { zoomError } from '@lib/zoom-helpers/types';
import { ZOOM_ERROR_CODES } from '@lib/zoom-helpers/error-codes';
import { logToCloudWatch } from '@services/logger.service';
import { ZOOM_JOIN_MEETING_URL_REGEX } from '@services/platform-service';

declare global {
  interface Window {
    zoomIntervalId: number | null;
    zoomError: any;
    startZoomCommentsProcessor: (liveStreamId: string) => void;
    commentsArr: any[];
  }
}

export const resetZoomGlobals = () => {
  if (window.zoomIntervalId) {
    clearInterval(window.zoomIntervalId);
    window.zoomIntervalId = null;
  }
  window.zoomError = null;
  // window.commentsArray = [];
};

export const resetZoomError = () => {
  window.zoomError = null;
};

export const startZoomCommentsProcessor = (liveStreamId: string) => {
  window.startZoomCommentsProcessor(liveStreamId);
};

export const isInBreakoutRoom = (bid: string | number) => {
  if (typeof bid === 'string' && bid.length > 0) {
    return true;
  }
  if (typeof bid === 'number') {
    return true;
  }
  return false;
};

export default resetZoomGlobals;

export const getCustomZoomError = (error: zoomError, liveStreamId: string, joinParams: object = {}) => {
  try {
    let tmpError = { ...error, source: 'zoom', originalError: error, joinParams };
    if (tmpError.reason === 'dependent assets are not accessible') {
      tmpError.message = 'Please disable Ad blocking extensions and try again!';
    }
    if (tmpError.errorCode && ZOOM_ERROR_CODES[tmpError.errorCode]) {
      return { ...tmpError, ...ZOOM_ERROR_CODES[tmpError.errorCode] };
    }
    if ((!tmpError.message || tmpError.message === '') && tmpError?.reason) {
      tmpError.message = tmpError.reason;
    }
    tmpError.message = `Zoom reported a connection error: ${tmpError.message || 'Unknown error'}`;
    return tmpError;
  } catch (e) {
    logToCloudWatch('Error in getCustomZoomError', { error, liveStreamId }, 'ERROR');
  }
};

export const zoomLinkParser = (url: string) => {
  let joinUrl;
  let urlType;
  let meetingId;
  let pwd;
  let tk;
  let zak;
  let matches = url.match(ZOOM_JOIN_MEETING_URL_REGEX);

  if (!matches || matches.length < 3) {
    return { urlType, meetingId, pwd, tk, zak };
  }

  joinUrl = matches[0];
  urlType = matches[1];
  meetingId = matches[2];

  if (matches[3]) {
    const queryParams = new URLSearchParams(matches[3]);
    pwd = queryParams.get('pwd') || undefined;
    tk = queryParams.get('tk') || undefined;
    zak = queryParams.get('zak') || undefined;
  }

  return { joinUrl, urlType, meetingId, pwd, tk, zak };
};

export const zoomLinkValidator = (name: string = 'linkValidation') => {
  return string().test({
    name,
    test(value = '', ctx) {
      let message = '';
      if (!value) {
        message = 'Please enter your meeting link.';
      }

      if (!value && message) {
        return ctx.createError({ message });
      }

      if (value?.includes('events')) {
        return ctx.createError({
          message:
            'Event link cannot be used to join a meeting/webinar.',
        });
      }

      if (value?.includes('register')) {
        return ctx.createError({
          message:
            'Registration link cannot be used to join a meeting/webinar.',
        });
      }

      const { meetingId } = zoomLinkParser(value);
      if (meetingId) return true;

      return ctx.createError({ message: 'Enter a valid link.' });
    },
  }).transform((value) => {
    const { joinUrl } = zoomLinkParser(value);
    if (joinUrl) return joinUrl;
    return value;
  });
};
